import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import useFetchCauseCategories from '../../hooks/fetchCauseCategories';
import { message, Upload, Switch, Select, TimePicker, DatePicker, Form, Input } from 'antd';
import { LeftCircleOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { app } from '../../config';
import moment from 'moment';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';

const { TextArea } = Input;
const Addevent = () => {
  const [form] = Form.useForm();
  dayjs.extend(customParseFormat);
  const { t } = useTranslation(['common']);
  const [uploadObj, setUploadObj] = useState({});
  const [uploadLogo, setuploadLogo] = useState(true);
  const [uploadedImg, setUploadedImg] = useState('');
  const [addUserResp, setAddUserResp] = useState({});
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  let user = JSON.parse(localStorage.getItem('user'));
  const orgResp = useFetchOrganizations();
  const orgs = orgResp.response ? orgResp.response.data : [];
  // const causeCatResp = useFetchCauseCategories();
  const token = getTokenfromUserObj();
  const headers = { auth: token };
  // const causeCat = causeCatResp.response ? causeCatResp.response.data : [];
  let navigate = useNavigate();
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const handleuploadChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      console.log(info.file.status);
      info.file ? console.log(info.file.response.data.Location) : console.log('Not found');
      info.file ? setUploadedImg(info.file.response.data.Location) : ' ';
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setuploadLogo(false);
        setImageUrl(url);
      });
    }
  };
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  };
  const uploadData = async (uploadObj) => {
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/event/add`, uploadObj, { headers: { auth: token } });
      if (res.data.statusCode === 200) {
        setAddUserResp(res.data);
        setTimeout(() => {
          if (user.userType === 'A') navigate('/event/view');
          else if (user.userType === 'O') navigate('/events/view');
        }, 1000);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const onFinish = (values) => {
    console.log('Success:', values);
    setUploadObj({
      eventName: values.eventName ? values.eventName : '',
      image: uploadedImg ? uploadedImg : ' ',
      organizationId: user.userType === 'A' && values.organizationId ? values.organizationId : user.organizationId,
      speaker: values.speaker ? values.speaker : '',
      startDate: values.startDate ? values.startDate.format().split('T')[0] : '',
      endDate: values.endDate ? values.endDate.format().split('T')[0] : '',
      startTime: values.startTime && values.startTime._d ? values.startTime._d.toTimeString().split(' ')[0] : '',
      endTime: values.endTime && values.endTime._d ? values.endTime._d.toTimeString().split(' ')[0] : '',
      isActive: values.isActive === true ? 1 : 0,
      description: values.description ? values.description : '',
      createdByUserId: user.userId,
    });
    setShow(true);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  function goBack() {
    if (user.userType === 'A') navigate('/event/view', { replace: true });
    else if (user.userType === 'O') navigate('/events/view', { replace: true });
  }
  const onChange = (time, timeString) => {
    console.log(time, timeString);
  };
  window.addEventListener('popstate', goBack);
  console.log(uploadObj);
  const submitData = () => {
    console.log('calling');
    if (Object.keys(uploadObj).length > 0) {
      uploadData(uploadObj);
    }
  };
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div class='container'>
      <div class='row mt-4 w-75 tbl'>
        <div class='row topbar ' style={{ height: '70px' }}>
          <div class='col-lg-4 fs-3 fw-bold'>
            {' '}
            <LeftCircleOutlined
              onClick={() => {
                if (user.userType === 'A') navigate('/event/view', { replace: true });
                else if (user.userType === 'O') navigate('/events/view', { replace: true });
              }}
              className='mt-3 ml-4 back-icon'
              style={{ fontSize: '38px' }}
            />
          </div>
          <div class='col-lg-7 fs-3 fw-bold '>
            <h2 class=' mb-5 mt-4 fw-bold text-white fs-4 ml-4'> {t('Add Event')} </h2>
          </div>{' '}
        </div>

        <div class='col-lg-11 mb-5 mt-3 '>
          <div class='col-lg-9 align-self-center mt-2 mb-4'>
            <Form
              form={form} 
              name='basic'
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              style={{
                maxWidth: 600,
              }}
              initialValues={{
                remember: true,
                ['id']: 1,
                ['causename']: 'Hammad',
                ['isActive']: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete='off'
            >
              {user.userType === 'A' ? (
                <Form.Item
                  label='Organization'
                  name='organizationId'
                  rules={[
                    {
                      required: true,
                      message: 'Select organization',
                    },
                  ]}
                >
                  <Select
                    listHeight={250}
                    listItemHeight={500}
                    placeholder='Select Organization'
                    style={{
                      width: 260,
                    }}
                  >
                    {orgs.map((orgs) => {
                      return (
                        <Option key={orgs.organizationId} value={orgs.organizationId}>
                          {orgs.organizationName}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              ) : (
                ' '
              )}

              <Form.Item
                colon={false}
                label='Event Name'
                name='eventName'
                rules={[
                  {
                    required: true,
                    message: 'Enter event name',
                  },
                ]}
              >
                <Input placeholder='Enter Event Name' maxLength={20} />
              </Form.Item>
              <Form.Item
                colon={false}
                label='Speaker Name'
                name='speaker'
                rules={[
                  {
                    required: false,
                    message: 'Please input your username!',
                  },
                ]}
              >
                <Input placeholder='Enter Speaker Name' />
              </Form.Item>
              <Form.Item label='Image' colon={false} name='image'>
                <Upload
                  // name="avatar"
                  listType='picture-card'
                  className='avatar-uploader'
                  showUploadList={false}
                  action={`${app.URL}/upload/eventimage`}
                  headers={headers}
                  beforeUpload={beforeUpload}
                  onChange={handleuploadChange}
                >
                  {uploadLogo ? (
                    loading ? (
                      uploadButton
                    ) : (
                      uploadButton
                    )
                  ) : (
                    <img
                      src={imageUrl}
                      alt='avatar'
                      style={{
                        width: '100%',
                      }}
                    />
                  )}
                </Upload>
              </Form.Item>

              <Form.Item
                colon={false}
                label='Start Date'
                name='startDate'
                rules={[
                  {
                    required: true,
                    message: 'select Start date',
                  },
                ]}
              >
                <DatePicker
                  placeholder='Select Start Date'
                  // disabledDate={(current) => {
                  //   let customDate = moment().format("MM-DD-YYYY");
                  //   return current && current < moment(customDate, "MM-DD-YYYY");
                  // }}
                />
              </Form.Item>
              <Form.Item
                colon={false}
                label='Start Time'
                name='startTime'
                rules={[
                  {
                    required: true,
                    message: 'Select Start Time',
                  },
                ]}
              >
                <TimePicker style={{ width: 160 }} value={moment('10:30', 'HH:mm')} placeholder='Select Start Time' />
              </Form.Item>

               
              <Form.Item
                colon={false}
                label='End Date'
                name='endDate'
                rules={[
                  {
                    required: true,
                    message: 'Select End Date',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const startDate = getFieldValue('startDate');
                      if (value && startDate && value.isBefore(startDate)) {
                        return Promise.reject(new Error('End Date must be after Start Date'));
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
                
              >
                {/* <DatePicker
                  placeholder='Select End Date'
                  disabledDate={(current) => {
                    let customDate = moment().format("MM-DD-YYYY");
                    
                    return current && current < moment(customDate, "MM-DD-YYYY");
                  }}
                /> */}
                <DatePicker
                  placeholder='Select End Date'
                  disabledDate={(current) => {
                    const customDate = moment(); // Get the current date
                    const startDate = form.getFieldValue('startDate'); // Get the selected start date

                    // Disable dates before current date and before or equal to start date
                    return current && (current < customDate.startOf('day') || current <= moment(startDate).startOf('day'));
                  }}
                />
              </Form.Item> 

              
              {/* <Form.Item
                colon={false}
                label="End Date"
                name="endDate"
                dependencies={['startDate']}
                rules={[
                  {
                    required: true,
                    message: 'Select End Date',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const startDate = getFieldValue('startDate');
                      if (value && startDate && value.isBefore(startDate)) {
                        return Promise.reject(new Error('End Date must be after Start Date'));
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <DatePicker
                  placeholder="Select End Date"
                  disabledDate={(current) => {
                    let customDate = moment().format("MM-DD-YYYY");
                    // Disable all dates before the selected start date
                    const startDate = form.getFieldValue('startDate');
                    return startDate && current && current <= moment(startDate, "MM-DD-YYYY");
                    // return startDate && current && current < moment(startDate).endOf('day'); 
                  }}
                />
              </Form.Item> */}


              <Form.Item
                colon={false}
                label='End Time'
                name='endTime'
                rules={[
                  {
                    required: true,
                    message: 'Select End Time',
                  },
                ]}
              >
                <TimePicker style={{ width: 160 }} placeholder='Select End Time' onChange={onChange} defaultOpenValue={dayjs('11:00:00', 'HH:mm:ss')} />
              </Form.Item>

              <Form.Item
                colon={false}
                label='Description'
                name='description'
                rules={[
                  {
                    message: 'Please input your password!',
                  },
                ]}
              >
                <TextArea placeholder='Enter Event Description' rows={4} />
              </Form.Item>
              <Form.Item label='Active' colon={false} valuePropName='checked' name='isActive'>
                <Switch />
              </Form.Item>
              <Form.Item
                colon={false}
                wrapperCol={{
                  offset: 8,
                  span: 16,
                }}
              >
                {addUserResp.statusCode === 200 ? (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title className='text-center'>Success</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{addUserResp.message}</Modal.Body>
                    <Modal.Footer></Modal.Footer>
                  </Modal>
                ) : addUserResp.statusCode === 400 ? (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title className='text-center'>Failed</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{addUserResp.data.message}</Modal.Body>
                    <Modal.Footer></Modal.Footer>
                  </Modal>
                ) : (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title>Confirmation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Are you sure you want to add Event?</Modal.Body>
                    <Modal.Footer>
                      <Button variant='secondary' onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button variant='primary' htmlType='submit' onClick={submitData}>
                        Save Changes
                      </Button>
                    </Modal.Footer>
                  </Modal>
                )}
                <button type='primary' class='btn btn-primary button' htmlType='submit'>
                  Save
                </button>
                {/* <Button type="primary" htmlType="submit">
  Submit
</Button> */}
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Addevent;
